import React from 'react';

const ApoioContext = React.createContext();

export default ApoioContext;